// src/api/courses.ts
import api from './axios';
import {
    Course,
    CreateCourseRequest,
    UpdateCourseRequest
} from '../types/course';

export async function getCourses(): Promise<Course[]> {
    const res = await api.get<Course[]>('/courses');
    return res.data;
}

export async function createCourse(
    data: CreateCourseRequest
): Promise<Course> {
    const res = await api.post<Course>('/courses', data);
    return res.data;
}

export async function updateCourse(
    id: string,
    data: UpdateCourseRequest
): Promise<Course> {
    const res = await api.patch<Course>(`/courses/${id}`, data);
    return res.data;
}

export async function deleteCourse(id: string): Promise<void> {
    await api.delete(`/courses/${id}`);
}

export function unarchiveCourse(id: string): Promise<Course> {
    return api
        .patch<Course>(`/courses/${id}/unarchive`)
        .then(res => res.data);
}

// same here: use `api.get` and type it
export function getArchivedCourses(): Promise<Course[]> {
    return api
        .get<Course[]>('/courses/archived')
        .then(res => res.data);
}

export function getCoursesByTeacher(teacherId: string): Promise<Course[]> {
     return api
           .get<Course[]>(`/courses/teacher/${teacherId}`)
      .then(res => res.data);
}

export function migrateCourseToGroup(
    id: string,
    groupEmail: string,
    groupName?: string
): Promise<{ success: boolean; message: string; groupEmail: string; courseId: string }> {
    return api
        .post(`/courses/${id}/migrate-to-group`, { groupEmail, groupName })
        .then(res => res.data);
}

export function getCourse(id: string): Promise<Course> {
    return api.get<Course>(`/courses/${id}`).then(res => res.data);
}

export function getMigrationStatus(id: string): Promise<Pick<Course, 'driveGroupEmail' | 'isMigratedToGroup' | 'groupMigrationStatus' | 'groupMigrationStats'>> {
    return api.get(`/courses/${id}/migration-status`).then(res => res.data);
}